import { prefix } from '@goldwasserexchange/react-topmodel';
export var buttonPrefixer = prefix('Button');
